import { styled } from 'styled-components';

import { mq } from '@/shared/ui/styled';

export const StyledTabCharacteristicWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 59px;
    height: 100%;
    border-bottom: 1px solid ${({ theme }) => theme.color.neutral400};
    padding: 20px 0;
    gap: 10px;
    font-weight: 400;
    font-size: ${({ theme }) => theme.fontSize.sm};
    line-height: 18.4px;

    ${mq.gt.md} {
        font-size: ${({ theme }) => theme.fontSize.md};
        line-height: 19.2px;
    }
`;

export const StyledTabCharacteristicValue = styled.div<{ isTextRight?: boolean }>`
    flex: 1;
    text-align: ${({ isTextRight }) => (isTextRight ? 'right' : 'left')};
`;
